<template>
    <div>

        <div class="page-header-controls-search">
            <input type="text" v-model="search" @input="doSearch" :placeholder="$t('label.materialName')">
        </div>

    </div>
</template>

<script>
  import _ from 'lodash'

  export default {
    data () {
      return {
        search: null
      }
    },
    methods: {
      doSearch: _.debounce(function (e) {
        this.$events.fire('material-search', {
          search: this.search
        })
      }, 500)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Organization/Settings/Materials/Search.vue